// eslint-disable-next-line import/prefer-default-export
export const FETCH_TRANSLATE_LISTING = 'FETCH_TRANSLATE_LISTING';
export const FETCH_TRANSLATE_LISTING_SUCCESS =
  'FETCH_TRANSLATE_LISTING_SUCCESS';
